import React, { useContext, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./SinglePartition.scss";
import { Navigation, Pagination } from "swiper";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import SpecalBaskets from "../landing/SpecialBaskets.tsx";

import plus from "../../assets/images/Icon feather-plus.png";
import SupplierContext from "context/SupplierContext";
import Product from "components/bussiness-tabs/Product";
import SinglePartitionNew from "./singlePartitionNew";
const SinglePartition = ({ data, type, typeSection }) => {
  const { setProduct } = useContext(SupplierContext);
  const displaySection = () => {
    if (typeSection == "amazing") {
      return (
        <>
          {" "}
          <AmazingSuggestion></AmazingSuggestion>
        </>
      );
    } else if (typeSection == "disconter")
      return (
        <>
          {" "}
          <Discounters></Discounters>
        </>
      );
  };

  return (
    <>
      {displaySection()}
      {/* {typeSection == "disconter" ? (
        <Discounters></Discounters>
      ) : (
        <AmazingSuggestion></AmazingSuggestion>
      )} */}
      {typeSection != "amazing" ? (
        <div className="sliderContainer">
          <Swiper
            navigation={true}
            modules={[Navigation, Pagination]}
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              slidesPerView: 1,
              spaceBetween: 10,
              380: {
                slidesPerView: 1.5,
              },
              497: {
                slidesPerView: 2,
              },
              600: {
                slidesPerView: 2.5,
              },
              685: {
                slidesPerView: 3,
                spaceBetween: 5,
              },
              800: {
                slidesPerView: 3.5,
                spaceBetween: 5,
              },
              900: {
                slidesPerView: 4,
                spaceBetween: 2,
              },
              1118: {
                slidesPerView: 4.5,
                spaceBetween: 2,
              },
              1200: {
                slidesPerView: 5,
              },
              1390: {
                slidesPerView: 5.5,
              },
              1500: {
                slidesPerView: 6,
              },
              1630: {
                slidesPerView: 6.5,
              },
              1700: {
                slidesPerView: 7,
                spaceBetween: 8,
              },
              1800: {
                slidesPerView: 7.5,
                spaceBetween: 2,
              },
            }}
            className="mySwiper SinglePartition"
          >
            {data != undefined && data.length > 0 ? (
              <div>
                {data.map((value, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <SinglePartitionNew
                        value={value}
                        type={type}
                        setProduct={setProduct}
                      ></SinglePartitionNew>
                    </SwiperSlide>
                  );
                })}
              </div>
            ) : null}
          </Swiper>
        </div>
      ) : (
        <div className="sliderContainer2">
          <Swiper
            navigation={true}
            modules={[Navigation, Pagination]}
            spaceBetween={1}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              slidesPerView: 1,
              spaceBetween: 1,
              380: {
                slidesPerView: 1.5,
                spaceBetween: 2,
              },
              490: {
                slidesPerView: 2,
              },
              600: {
                slidesPerView: 2.5,
                spaceBetween: 5,
              },
              700: {
                slidesPerView: 3,
                spaceBetween: 2,
              },
              929: {
                slidesPerView: 3.5,
                spaceBetween: 2,
              },
              1000: {
                slidesPerView: 4,
                spaceBetween: 2,
              },
              1250: {
                slidesPerView: 4.5,
                spaceBetween: 2,
              },

              1500: {
                slidesPerView: 5,
                spaceBetween: 15,
              },
              1700: {
                slidesPerView: 5.5,
                spaceBetween: 15,
              },
              1750: {
                slidesPerView: 6,
                spaceBetween: 15,
              },
              1850: {
                slidesPerView: 6.5,
                spaceBetween: 15,
              },
            }}
            className="mySwiper SinglePartition"
          >
            {data != undefined && data.length > 0 ? (
              <div>
                {data.map((value, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <SinglePartitionNew
                        value={value}
                        type={type}
                        setProduct={setProduct}
                      ></SinglePartitionNew>
                    </SwiperSlide>
                  );
                })}
              </div>
            ) : null}
          </Swiper>
        </div>
      )}
    </>
  );
};
export default SinglePartition;

//تخفیف دارها
export function Discounters() {
  return (
    <div className="d-flex justify-content-center align-items-center Discounters">
      <p className="Discounters-txt">تخفیف دارها</p>
    </div>
  );
}
//شگفت انگیز
export function AmazingSuggestion() {
  return (
    <div className="d-flex-row  justify-content-center align-items-center suggestion">
      <div className="suggestion-txt">پیشنهاد</div>
      <div className="suggestion-txt">شگفت انگیز </div>
      <div className="suggestion-txt2">پیشنهاد شگفت انگیز</div>
    </div>
  );
}

const item = () => {};
